import { autoserialize, autoserializeAs } from 'cerialize';

import { MiniDriver } from './mini-driver';

export class SignatureRequestStatus {

  @autoserialize
  signatureRequestId: string;

  @autoserialize
  stateCode: string;

  @autoserialize
  statusName: string;

  @autoserialize
  documentTypeName: string;

  @autoserializeAs(MiniDriver)
  miniDriver: MiniDriver;

  @autoserializeAs(Date)
  createdDate: Date;
}
